function setSelect2Title(el) {
    var lbl = $(el).next(".select2").find(".select2-selection__rendered");
    var placeHolderText = $(lbl).find(".select2-selection__placeholder").text().trim();
    if (!$(lbl).attr("title")) {
        $(lbl).attr("title", placeHolderText)
    }
}

export default function initSelect2Title(el) {
    setSelect2Title(el);
    $(el).on("change", function (e) {
        setSelect2Title(this);
    });
}